// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperSideNav_root__1Rp9f","tabs":"LayoutWrapperSideNav_tabs__2POAn","tab":"LayoutWrapperSideNav_tab__8dGpk"};